import axios from 'axios';
import * as actionTypes from './actionType';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetAllUserList = (data) => ({
  type: actionTypes.GET_ALL_USER_LIST_DATA,
  userListData: data,
});

export const getAllUserList = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_USERLIST_DETAILS)
    .then((response) => {
      dispatch(dispatchGetAllUserList(response));
    })
    .catch(() => {
      dispatch(dispatchGetAllUserList({ error: 'API failed' }));
    });
};

export const setErrorMessages = (payload) => {
  return {
    type: actionTypes.SET_ERROR_MESSAGES,
    payload,
  };
};

export const setGridData = (payload) => {
  return {
    type: actionTypes.SET_GRID_DATA,
    payload,
  };
};
export const clearReduxUserListScreen = () => (dispatch) => {
  dispatch(setGridData([]));
  dispatch(setErrorMessages([]));
  dispatch(dispatchGetAllUserList([]));
};
